import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { ITask, ITaskRequest, TaskStatus } from '../interfaces/task.interface';

interface Page<T> {
    content: T[];
    totalElements: number;
    totalPages: number;
    number: number;
    size: number;
}

const listParams = (page: number, size: number, statuses?: TaskStatus[]) => {
    const params: Record<string, unknown> = { page, size };
    if (statuses && statuses.length > 0) params.statuses = statuses;
    return params;
};

export const TaskService = {
    create: async (institutionId: string, request: ITaskRequest): Promise<ITask> => {
        const response = await axios.post(ENDPOINTS.TASK.CREATE(institutionId), request, {
            headers: { ...AuthService.getAuthHeader(), 'Content-Type': 'application/json' },
        });
        return response.data;
    },

    update: async (taskId: string, institutionId: string, request: ITaskRequest): Promise<ITask> => {
        const response = await axios.put(ENDPOINTS.TASK.UPDATE(taskId, institutionId), request, {
            headers: { ...AuthService.getAuthHeader(), 'Content-Type': 'application/json' },
        });
        return response.data;
    },

    delete: async (taskId: string, institutionId: string): Promise<void> => {
        await axios.delete(ENDPOINTS.TASK.DELETE(taskId, institutionId), {
            headers: AuthService.getAuthHeader(),
        });
    },

    updateStatus: async (taskId: string, status: TaskStatus): Promise<ITask> => {
        const response = await axios.patch(ENDPOINTS.TASK.UPDATE_STATUS(taskId), { status }, {
            headers: { ...AuthService.getAuthHeader(), 'Content-Type': 'application/json' },
        });
        return response.data;
    },

    myTasks: async (institutionId: string, page = 0, size = 20, statuses?: TaskStatus[]): Promise<Page<ITask>> => {
        const response = await axios.get(ENDPOINTS.TASK.MY(institutionId), {
            headers: AuthService.getAuthHeader(),
            params: listParams(page, size, statuses),
        });
        return response.data;
    },

    assignedByMe: async (institutionId: string, page = 0, size = 20, statuses?: TaskStatus[]): Promise<Page<ITask>> => {
        const response = await axios.get(ENDPOINTS.TASK.ASSIGNED_BY_ME(institutionId), {
            headers: AuthService.getAuthHeader(),
            params: listParams(page, size, statuses),
        });
        return response.data;
    },

    adminList: async (institutionId: string, page = 0, size = 20, statuses?: TaskStatus[]): Promise<Page<ITask>> => {
        const response = await axios.get(ENDPOINTS.TASK.ADMIN_LIST(institutionId), {
            headers: AuthService.getAuthHeader(),
            params: listParams(page, size, statuses),
        });
        return response.data;
    },

    getById: async (taskId: string): Promise<ITask> => {
        const response = await axios.get(ENDPOINTS.TASK.GET(taskId), {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },
};
